import React, { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  FiArrowLeft,
  FiPackage,
  FiCalendar,
  FiDollarSign,
  FiUser,
  FiPhone,
  FiMapPin,
  FiHome,
  FiHash,
  FiCheckCircle,
  FiActivity,
} from "react-icons/fi";
import Header from "../../components/Header";
import Button from "../../components/Button";
import "./style.scss";

const Detail = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const location = useLocation();
  const { orderDetail, deptDetail } = location.state || {};

  const getOrderStatus = (e) => {
    switch (e) {
      case "0":
        return "暂存";
      case "1":
        return "待生产";
      case "2":
        return "生产中";
      case "3":
        return "运输中";
      case "4":
        return "待安装";
      case "5":
        return "已安装";
      default:
        return "未知状态";
    }
  };

  if (loading) {
    return (
      <div className="detail-page">
        <Header
          title="订单详情"
          leftIcon={<FiArrowLeft />}
          onLeftClick={() => navigate("/")}
        />
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>正在加载订单信息...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="detail-page">
        <Header
          title="订单详情"
          leftIcon={<FiArrowLeft />}
          onLeftClick={() => navigate("/")}
        />
        <div className="error-container">
          <p className="error-message">{error}</p>
          <Button onClick={() => navigate("/")}>返回查询</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="detail-page">
      <Header
        title="订单详情"
        leftIcon={<FiArrowLeft />}
        onLeftClick={() => navigate("/")}
      />
      <div className="card">
        <div className="card-header">
          <FiPackage />
          <h3>基本信息</h3>
        </div>
        <div className="card-body">
          <div className="info-row">
            <div className="info-label">
              <FiHash />
              <span>订单编号</span>
            </div>
            <div className="info-value">{orderDetail.orderNumber}</div>
          </div>
          <div className="info-row">
            <div className="info-label">
              <FiMapPin />
              <span>收货地址</span>
            </div>
            <div className="info-value">{orderDetail.deliveryAddress}</div>
          </div>

          <div className="info-row">
            <div className="info-label">
              <FiHome />
              <span>下单门店</span>
            </div>
            <div className="info-value">{orderDetail.storeName}</div>
          </div>

          {/* <div className="info-row">
            <div className="info-label">
              <FiMapPin />
              <span>门店地址</span>
            </div>
            <div className="info-value">{order.storeAddress}</div>
          </div> */}

          <div className="info-row">
            <div className="info-label">
              <FiPhone />
              <span>门店联系方式</span>
            </div>
            <div className="info-value">{deptDetail?.phone || "暂无数据"}</div>
          </div>

          <div className="info-row">
            <div className="info-label">
              <FiUser />
              <span>负责人</span>
            </div>
            <div className="info-value">{orderDetail.responsiblePerson}</div>
          </div>

          {/* <div className="info-row">
            <div className="info-label">
              <FiDollarSign />
              <span>订单金额</span>
            </div>
            <div className="info-value">¥{orderDetail.amount}</div>
          </div> */}

          <div className="info-row">
            <div className="info-label">
              <FiCalendar />
              <span>下单时间</span>
            </div>
            <div className="info-value">{orderDetail.orderTime}</div>
          </div>

          <div className="info-row">
            <div className="info-label">
              <FiCheckCircle />
              <span>订单状态</span>
            </div>
            <div className="info-value">
              <span
                className="status-tag"
                data-status={orderDetail.orderStatus}
              >
                {getOrderStatus(orderDetail.orderStatus)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Detail;
